type Props = {
  className?: string;
};

const SearchIcon = (props: Props): JSX.Element => {
  const { className } = props;
  return (
    <svg
      className={className}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12.5 13L16.5 17.5" stroke="currentColor" strokeWidth="1.6" />
      <circle cx="8" cy="8" r="7.2" stroke="currentColor" strokeWidth="1.6" />
    </svg>
  );
};

export default SearchIcon;
